import { Component } from 'react';
import Styles from './Styles.module.scss';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: !!error, error };
  }

  componentDidCatch(error, info) {
    console.error(error);
    console.error(info);
    this.setState({ hasError: !!error, error, info });
    // You can also log the error to an error reporting service
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    const { error, info } = this.state;

    return (
      <div className={Styles.container}>
        <h2 className={Styles.errorHeadline}>{`500 Error`}</h2>
        <p
          className={
            Styles.errorDescription
          }>{`Sorry, Something went wrong. Our team has been notified and will rectify the issue as soon as possible.`}</p>
        <p className={Styles.errorDescription}>
          {`You can try to refresh the page or try again later.`}
        </p>
        <p className={Styles.technicalDetails}>
          Technical Details:
          <pre>{JSON.stringify({ error, info }, null, 2)}</pre>
        </p>
      </div>
    );
  }
}

export default ErrorBoundary;
